import { createContext } from 'react';

export const DefaultLanguageContext = createContext();
export const LanguageContext = createContext();
export const MakeFocusableContext = createContext();
export const RefetchStacksContext = createContext();
export const PreloadContext = createContext();
export const IsOttContext = createContext();
export const DevContext = createContext();
export const IsPMContext = createContext();
export const VendorsContext = createContext();